import React, { FC, useContext } from "react";
import { LanguageContext } from "common/contexts/LanguageContext";
import SimpleModal from "common/components/dialogs/SimpleModal";
import { Button, DialogActions } from "@mui/material";
import theme from "common/theme/theme";

interface IProps {
    isOpen: boolean;
    setOpen: () => void;
}

const ObstructionInfo: FC<IProps> = (props) => {
    const { isOpen, setOpen } = props;

    const { getString } = useContext(LanguageContext);

    return (
      <SimpleModal title={getString("dlg_obsinfo_title")} maxWidth="xs" isOpen={isOpen} setOpen={setOpen}>
      <DialogActions sx={{justifyContent:'center', paddingTop:'24px', display: "block", textAlign:'center'}}>
        {getString("dlg_obsinfo_info")}
        <div style={{width: '100%', alignItems:'center', paddingTop: '8px'}}><Button
          key={getString("cmn_ok").replace(/\s/g, "")}
          autoFocus={true}
          sx={{
            margin: 0,
            padding: theme.spacing(1, 2),
          }}
          variant="contained"
          color="primary"
          onClick={setOpen}
          data-testid={`${getString("cmn_ok").replace(/ /g, "")}Input`}
        >
          {getString("cmn_ok")}
        </Button></div>
        
      </DialogActions>
    </SimpleModal>
    );
}

export default ObstructionInfo;